import type { PopupData } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class WizardTourPopupWizardDataboardIntroComponent extends PopupInnerModalComponent<PopupData.None> {
	<template>
		<div class="content">

			<img src="/images/intro-tour/2.png" width="354" height="272" alt />

			<h3>Bring all your data into one place</h3>

			<p>
				Databox really shines when you connect all of your most-loved (and most-critical)
				data sources. With
				<strong>75+ one-click integrations</strong>,
				<strong>4,000+ built-for-you metrics</strong>, and so many ways to pull in your
				data, the process gets even smoother from here.
			</p>

			<div class="controls2 controls2--center">
				<SubmitButtonComponent
					@text="Let’s do it >"
					@size="big"
					@theme="grey-outlined"
					@onTrigger={{this.close}}
				/>
			</div>

		</div>
	</template>
}
